import React, { useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

import ActiveLearningClassDataContents from "../../../templates/teacher/ActiveLearningClassDataContents";
import {
  Context,
  fetchActiveLearningStudentAnswers,
  fetchActiveLearningThemes,
} from "../../../teacherStore";

export default () => {
  const { dispatch } = useContext(Context);
  const { student_id } = useParams();

  useEffect(() => {
    dispatch(fetchActiveLearningThemes());
    dispatch(fetchActiveLearningStudentAnswers(Number(student_id)));
  }, [student_id, dispatch]);

  return <ActiveLearningClassDataContents />;
};
